import Arrow from 'components/elements/icons/ForwardArrowIcon'
import LinkText from 'components/elements/texts/LinkText'
import { HistoryStackContext } from 'contexts/HistoryStackContext'
import React, { useCallback, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { transitionWithAction } from 'utils/commonUtils'
import { StatusProps } from 'utils/status'

/**
 * アイコン付きリンク
 */
const LinkLine: React.FC<LinkLineProps> = (props) => {
  const history = useHistory()
  const historyStackContext = useContext(HistoryStackContext)

  const linkClick = useCallback(async (): Promise<void> => {
    transitionWithAction(
      historyStackContext,
      props.label,
      () => {
        history.push(props.forwardTo)
      },
      props.withAction
    )
  }, [props.label, props.forwardTo, props.withAction])

  // TODO LineItemを使いたい（優先度低め）
  return (
    <LinkArea onClick={linkClick}>
      <LinkLineContent>
        {props.icon}
        <TextArea>
          <LinkText>{props.label}</LinkText>
        </TextArea>
        <Arrow />
      </LinkLineContent>
    </LinkArea>
  )
}

export type LinkLineProps = {
  icon: React.ReactNode
  forwardTo: string
  label: string
  withAction?: () => StatusProps
}

export const LinkArea = styled.div`
  position: relative;
  width: 100%;
  background: var(--color-content-background);
  border-bottom: 1px solid var(--color-border);

  &&:last-child {
    border-bottom: none;
  }
`

const LinkLineContent = styled.div`
  display: flex;
  align-items: center;
  height: 62px;
  margin-right: 11px;
  margin-left: 11px;
`

const TextArea = styled.div`
  flex: 1;
  margin-left: 11px;
`

export default LinkLine
